const CARD_BRAND_DISPLAY_NAMES: Record<string, string> = {
  amex: 'Amex',
  mastercard: 'Mastercard',
  visa: 'Visa',
  discover: 'Discover',
  diners: 'Diners Club',
  jcb: 'JCB',
  unionpay: 'UnionPay',
}

export function formatCardBrand(brand: string): string {
  if (!brand) return ''
  return CARD_BRAND_DISPLAY_NAMES[brand.toLowerCase()] || brand.charAt(0).toUpperCase() + brand.slice(1)
}
